import React from 'react';
import { ChevronRight } from 'lucide-react';
import ProductCard from '../../ui/ProductCard';
import { ProductCategory, Product } from '../../../types/Product';

interface ProductCategoryProps {
  category: ProductCategory;
  products: Product[];
  isEven: boolean;
}

const ProductCategorySection: React.FC<ProductCategoryProps> = ({ 
  category, 
  products,
  isEven
}) => {
  return (
    <section 
      id={category.id}
      className={`py-16 ${isEven ? 'bg-white' : 'bg-neutral'}`}
    >
      <div className="container-wide">
        <div className={`grid grid-cols-1 lg:grid-cols-12 gap-8 items-center ${
          isEven ? 'lg:flex-row-reverse' : ''
        }`}>
          {/* Category info */}
          <div className="lg:col-span-4">
            <h2 className="text-3xl font-bold text-primary-700 mb-4">
              {category.name}
            </h2>
            
            <div className="w-16 h-1 bg-secondary mb-6"></div>
            
            <p className="text-accent-700 mb-8">
              {category.description}
            </p>
            
            <a 
              href={`#${category.id}`}
              className="inline-flex items-center text-primary-600 hover:text-primary-800 font-medium transition-colors"
            >
              Več o kategoriji
              <ChevronRight size={16} className="ml-1" />
            </a>
          </div>
          
          {/* Products grid */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductCategorySection;